var scope_0 = require('/opt/buildhome/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1a0b62f07113813291a56d0d15c5b98b.js').default;
var scope_1 = require('/opt/buildhome/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/bb371b604cd58d6bdc41f05f30d23fb7.js').default;
var scope_2 = require('/opt/buildhome/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/dc9818fb68db7884b06c247ce631abf8.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2 )
    